import { IChecklistCategory, IChecklistItem, IChecklistItemRow, IChecklistPopulated } from "@mctypes/checklist.types";
import { IIssueApi } from "@schemas/issueSchema";

export const getChecklistTableRows = (
  editMode: boolean,
  checklist: IChecklistPopulated,
  checklistCategories: IChecklistCategory[],
  checklistItems: IChecklistItem[],
): IChecklistItemRow[] => {
  if (checklist == null || checklistCategories == null) {
    return [];
  }

  const tableRows: IChecklistItemRow[] = [];

  checklistCategories.forEach((cat) => {
    const catRow = {
      _id: cat._id,
      originalCategory: cat,
      dueDate: cat.dueDate,
      inactive: null,
      title: cat.title,
      reference: "",
      collapsed: cat.collapsed === true,
      originalItem: null,
      comment: null,
      commentImages: [],
      checks: null,
      itemId: null,
      categoryId: cat.categoryId,
      rowId: cat.categoryId.toString(),
    };

    let catRows: IChecklistItemRow[] = [];
    let catRowInactive = true;
    let catHasItemRows;

    checklistItems.forEach((item: IChecklistItem) => {
      if (item.category === cat._id) {
        catHasItemRows = true;
        catRows.push({
          _id: item._id,
          originalCategory: cat,
          inactive: item.inactive,
          title: item.title,
          reference: item.reference ?? "",
          collapsed: cat.collapsed === true,
          originalItem: item,
          comment: item.comment,
          commentImages: (item.commentImages ?? []).slice(0, 1),
          checks: {
            check1: item.checks?.check1,
            check2: item.checks?.check2,
            check3: item.checks?.check3,
            check4: item.checks?.check4,
            check5: item.checks?.check5,
            check6: item.checks?.check6,
            check7: item.checks?.check7,
            check8: item.checks?.check8,
            check9: item.checks?.check9,
            check10: item.checks?.check10,
            check11: item.checks?.check11,
            check12: item.checks?.check12,
            check13: item.checks?.check13,
            check14: item.checks?.check14,
            check15: item.checks?.check15,
          },
          itemId: item.itemId,
          categoryId: cat.categoryId,
          rowId: `${cat.categoryId}.${item.itemId}`,
          connectedIssues: item.connectedIssues as IIssueApi[],
          comments: item.comments,
          itemTags: item.itemTags ?? [],
        });

        if (item.inactive.isChecked === false) {
          catRowInactive = false;
        }
      }
    });

    catRow.inactive = {
      isChecked: catRowInactive === true && catHasItemRows === true,
      updatedDate: null,
      updatedBy: null,
    };

    if (
      editMode === false &&
      checklist.itemTagsActive === true &&
      checklist.activeItemTags.length > 0 &&
      catRows.length > 0
    ) {
      catRows = catRows.filter((row) => {
        return checklist.activeItemTags.every((tag) => row.itemTags.includes(tag));
      });

      if (catRows.length === 0) {
        return;
      }
    }

    tableRows.push(catRow, ...catRows);
  });

  return tableRows;
};

export const getCategoryCount = (categories: IChecklistCategory[]): number => {
  if (categories == null || categories.length === 0) {
    return 0;
  }

  return categories.reduce((acc, category) => (acc > category.categoryId ? acc : category.categoryId), 0);
};

export const getItemCount = (categoryId: string, items: IChecklistItem[]): number => {
  if (items == null || items.length === 0) {
    return 0;
  }

  const categoryItems = items.filter((item) => item.category === categoryId);
  return categoryItems.reduce((acc, item) => (acc > item.itemId ? acc : item.itemId), 0);
};
